const cashFormatter = new Intl.NumberFormat();
// お金を利用する場合、サーバー側から負数が返ってくるため、-を追記する必要ないです
export const cashFormat = (amount: number, usePlusSign?: boolean) =>
  `${amount > 0 && usePlusSign ? '+' : ''}${cashFormatter.format(amount)} `;
